import React, { useState, useEffect } from "react";
import "./NurseCalculator.scss";
import { IonModal, IonHeader, IonContent } from "@ionic/react";
import Loader from "../Loader/Loader";
import { utilService } from "../../../services/utilService";
import { NurseCalculatorInterface } from "./NurseCalculator.model";
import { nurseCalculatorService } from "./NurseCalculator.service";

interface sendSmsProps {
  showModal: boolean;
  onCancel: () => void;
}

const NurseCalculator: React.FC<sendSmsProps> = (props) => {
  var [nureCalculatorUrl, setNurseCalculatorUrl]: any = useState("");
  var [showLoader, setShowLoder]: any = useState(true);

useEffect(() => {
  if (props.showModal) {
    getStatusBoardListDetails();
  }
}, [props.showModal]);
//   useEffect(() => {
//   if (nureCalculatorUrl) {
//     window.open(nureCalculatorUrl, "_blank");
//     props.onCancel(); // close modal automatically
//   }
// }, [nureCalculatorUrl]);

  const getStatusBoardListDetails = async () => {
    setShowLoder(true);
    const params: any = getNurseCalculatorParams();
    const respNurseCalculatorResult: NurseCalculatorInterface =
      await nurseCalculatorService.getNurseCalculatorUrl(params);
    if (
      respNurseCalculatorResult.isSuccess &&
      respNurseCalculatorResult.result
    ) {
     const url = respNurseCalculatorResult.result?.[0]?.data?.[0]?.url;

if (url) {
setNurseCalculatorUrl(url);

// 👉 open immediately
window.open(url, "_blank");
}

// 👉 close modal
props.onCancel();
    } else {
      console.log("error");
      nurseCalculatorService.handleErrorResponse();
    }
    setShowLoder(false);
  };

  const getNurseCalculatorParams = () => {
    return {
      reg_code: utilService.getNetwork(),
    };
  };

  return (
    <IonModal
      isOpen={props.showModal}
      backdropDismiss={false}
      className="nurse-calculator-modal"
    >
      <IonHeader>
        <div className="cc-logo">
          <img
            src="assets/icon/logoIcon.svg"
            alt="Nserix"
            className="cc-logo-svg"
          />
          
        </div>
        <div
          className="input-icon icon-close icon-close-div"
          onClick={() => props.onCancel()}
        ></div>
      </IonHeader>

      <IonContent className="iframe-fix">
        {/* {nureCalculatorUrl !== "" && (
          // <iframe
          //   src={nureCalculatorUrl}
          //   frameBorder="0"
          //   width="100%"
          //   height="100%"
          // ></iframe>
        )} */}

        {showLoader && (
          <div className="loader-div">
            <Loader></Loader>
          </div>
        )}
      </IonContent>
    </IonModal>
  );
};

export default NurseCalculator;
